import { LazyAction, LazyModule, LazyImport } from 'owa-bundling-light';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarFunctionalBoot" */ './lazyIndex')
);

export const lazySetupCalendarFunctionalBoot = new LazyAction(
    lazyModule,
    m => m.setupCalendarFunctionalBoot
);

export const lazySetupCalendarDeeplinkFunctionalBoot = new LazyAction(
    lazyModule,
    m => m.setupCalendarDeeplinkFunctionalBoot
);

new LazyImport(
    new LazyModule(() => import(/* webpackChunkName: "OwaPersona" */ 'owa-persona')),
    m => m.changeModuleOrchestrator
)
    .import()
    .then(cmo => cmo.import().then(orchestrator => orchestrator()));
